import React, { useCallback, useContext, useRef } from 'react';
import classNames from 'classnames';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import NdaListModal from 'components/NdaListModal';
import { NDATemplate } from 'models/Nda';
import { Listing } from 'models/Listing';
import api from 'api';
import { OverlayRef } from 'ncoded-component-library/build/components/atoms/Overlay/Overlay.component';

import './AddNdaButton.styles.scss';

type AddNdaButtonProps = {
  className?: string;
  listingId: string;
  envelopeTemplateId: string;
  isDisabled?: boolean;
  setListing?: (listing: Listing) => void;
};

const AddNdaButton: React.FC<AddNdaButtonProps> = (props) => {
  const { className, envelopeTemplateId, isDisabled, listingId, setListing } =
    props;

  const { isSuperAdmin } = useContext(CurrentUserContext);

  const modalRef = useRef<OverlayRef>();

  const { t } = useTranslation();

  const classes = classNames('add-nda-button', className);

  const onUploadNda = useCallback(
    async (template: NDATemplate) => {
      const { data } = await api.portfolio.seller.linkEnvelopeTemplate(
        listingId,
        template.templateId,
        template.name,
      );

      setListing(data);
    },
    [listingId, setListing],
  );

  if (!isSuperAdmin || envelopeTemplateId) return null;

  return (
    <>
      <Button
        variant="outline"
        disabled={isDisabled}
        className={classes}
        onClick={() => {
          if (isDisabled) return;
          modalRef?.current?.open();
        }}
      >
        {t('connectNda')}
      </Button>

      {!isDisabled && (
        <NdaListModal
          ref={modalRef}
          description={t('connectNondisclosureAgrementWithDeal')}
          onSelectNda={onUploadNda}
        />
      )}
    </>
  );
};

export default AddNdaButton;
